/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
declare const window: any;

export class AppInitService {
  // This is the method you want to call at bootstrap
  public async init() {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await fetch(`server-config.json`);
      const config = await response.json();
      window.config = config;
      return config;
    } catch (error) {
      console.error('Error fetching config:', error);
      throw error;
    }
  }
}
